export default (state, action) => {
  const { pusherConnectionState } = state
  const { connected, error = null } = action.payload

  if (pusherConnectionState.connected === connected) return state
  return { ...state, pusherConnectionState: { connected, error } }
}
